export default __webpack_public_path__ + "static/media/white_two.1a093d44.jpg";